<template>
    <div v-if="loaded" class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="success" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
            <NevsButton class="error" @click="backClick"><i class="fa-solid fa-arrow-left"></i>
                {{ $LANG.Get('buttons.back') }}
            </NevsButton>
        </div>
        <NevsCard class="form">
            <NevsTextField v-model="group.name" :error="validation.name"
                           :label="'*' + $LANG.Get('fields.name') + ':'"></NevsTextField>
            <table class="group-persons-table">
                <tbody>
                    <tr v-for="(groupPerson, key) in group.persons" :key="key">
                        <td><NevsSelect v-model="groupPerson.person_id" :ajax="'select/persons'"></NevsSelect></td>
                        <td class="group-persons-table-action"><span :title="$LANG.Get('tooltips.delete')" class="group-button" @click="removePerson(key)"><i
                            class="fa-solid fa-trash"></i></span></td>
                    </tr>
                </tbody>
            </table>
            <NevsButton style="margin-top: 10px;" @click="addPerson()"><i class="fa-solid fa-user-plus"></i> {{ $LANG.Get('buttons.addPerson') }}</NevsButton>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";

export default {
    name: "EntityGroup",
    components: {NevsSelect, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            loaded: false,
            mode: this.$route.params.id === '0' ? 'add' : 'edit',
            group: {
                id: 0,
                name: '',
                persons: []
            },
            validation: {
                name: ''
            }
        }
    },
    methods: {
        addPerson() {
            this.group.persons.push({
                person_id: null
            });
        },
        removePerson(index) {
            this.group.persons.splice(index, 1);
        },
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        saveClick() {
            let valid = true;
            if (this.group.name === '') {
                valid = false;
                this.validation.name = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.validation.name = '';
            }
            if (!valid) {
                return;
            }

            let payload = JSON.parse(JSON.stringify(this.group));
            payload.persons = payload.persons.filter((person) => person.person_id !== null);
            let method = (this.mode === 'add') ? 'post' : 'put';
            let action = (this.mode === 'add') ? 'groups' : 'groups/' + this.group.id;
            let vm = this;
            this.$API.APICall(method, action, payload, (data, success) => {
                if (success) {
                    vm.$LOCAL_BUS.TriggerEvent('notification', {text: vm.$LANG.Get('alerts.recordSaved')});
                    vm.backClick();
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'clients');
        this.$store.commit('selectSubMenu', 'groups');

        if (this.mode === 'add') {
            this.$store.commit('setBreadcrumbs', [
                {
                    label: this.$LANG.Get('modules.clients'),
                    link: null
                },
                {
                    label: this.$LANG.Get('modules.groups'),
                    link: '/groups'
                },
                {
                    label: this.$LANG.Get('buttons.addGroup'),
                    link: null
                }
            ]);
            this.loaded = true;
        } else {
            let vm = this;
            this.$API.APICall('get', 'groups/' + this.$route.params.id, {}, (data, success) => {
                if (success && data.group !== null) {
                    vm.group = JSON.parse(JSON.stringify(data.group));
                    if (!Array.isArray(vm.group.persons)) vm.group.persons = [];
                    vm.$store.commit('setBreadcrumbs', [
                        {
                            label: vm.$LANG.Get('modules.clients'),
                            link: null
                        },
                        {
                            label: vm.$LANG.Get('modules.groups'),
                            link: '/groups'
                        },
                        {
                            label: vm.group.name,
                            link: null
                        }
                    ]);
                    vm.loaded = true;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    }
}
</script>

<style scoped>
.form {
    max-width: 600px;
    margin-bottom: 10px;
    padding: 15px;
}

.group-section-heading {
    margin: 15px 0 5px;
    font-size: 16px;
}

.group-button {
    margin-right: 10px;
    font-size: 14px;
    cursor: pointer;
}

.group-persons-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

.group-persons-table th {
    text-align: left;
    font-size: 12px;
    padding: 0 5px;
}

.group-persons-table td {
    padding: 0 5px;
    vertical-align: top;
}

.group-persons-table td.group-persons-table-action {
    width: 20px;
    vertical-align: middle;
    text-align: center;
}
</style>
